<template lang="pug">
AppProgressBar(
  :tracked="valuePercentage"
  :total="100"
  :bar-classes="barClasses"
)
</template>

<script>
import { get, kebabCase } from 'lodash-es';

import AppProgressBar from '~/components/AppProgressBar.vue';

export default {
  name: 'InsightsRankingProgressBar',
  components: {
    AppProgressBar,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
      validator: (value) => ['proficiency', 'list'].includes(value),
    },
    max: {
      type: Number,
      required: true,
    },
  },
  computed: {
    valuePercentage() {
      const value = get(this.item, 'value', 0);

      return value ? (value * 100) / this.max : value;
    },
    barClasses() {
      let classes = 'insights-ranking';

      classes += ` ${classes}-${this.type}`;

      if (this.type === 'proficiency') {
        classes += ` ${this.type}-${kebabCase(this.item.proficiency)}`;
      }

      return classes;
    },
  },
};
</script>
